// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"8a4823d8","308":"2248f452","582":"3a9a5aaa","796":"3fbeebd1","966":"508d7fbb"}[chunkId] + ".chunk.js";
};